<div class="dropdown d-inline">
  <button
    aria-label="condividi sui social"
    class="btn btn-dropdown dropdown-toggle text-decoration-underline d-inline-flex align-items-center fs-0"
    type="button"
    id="shareActions"
    data-bs-toggle="dropdown"
    aria-haspopup="true"
    aria-expanded="false"
  >
    <svg class="icon" aria-hidden="true">
      <use xlink:href="bootstrap-italia/dist/svg/sprites.svg#it-share"></use>
    </svg>
    <small>Condividi</small>
  </button>
  <div class="dropdown-menu shadow-lg" aria-labelledby="shareActions">
    <div class="link-list-wrapper">
      <ul class="link-list" role="menu">
        <li role="none">
          <a
            class="list-item"
            [href]="facebookShareUrl"
            role="menuitem"
            target="_blank"
          >
            <svg class="icon" aria-hidden="true" aria-label="Facebook">
              <use
                xlink:href="bootstrap-italia/dist/svg/sprites.svg#it-facebook"
              ></use>
            </svg>
            <span>Facebook</span>
          </a>
        </li>
        <li role="none">
          <a
            class="list-item"
            [href]="twitterShareUrl"
            role="menuitem"
            target="_blank"
          >
            <svg class="icon" aria-hidden="true" aria-label="Twitter">
              <use
                xlink:href="bootstrap-italia/dist/svg/sprites.svg#it-twitter"
              ></use>
            </svg>
            <span>Twitter</span>
          </a>
        </li>
        <li role="none">
          <a
            class="list-item"
            [href]="linkedinShareUrl"
            role="menuitem"
            target="_blank"
          >
            <svg class="icon" aria-hidden="true" aria-label="Linkedin">
              <use
                xlink:href="bootstrap-italia/dist/svg/sprites.svg#it-linkedin"
              ></use>
            </svg>
            <span>Linkedin</span>
          </a>
        </li>
        <li role="none">
          <a
            class="list-item"
            [href]="whatsappShareUrl"
            role="menuitem"
            target="_blank"
          >
            <svg class="icon" aria-hidden="true" aria-label="Whatsapp">
              <use
                xlink:href="bootstrap-italia/dist/svg/sprites.svg#it-whatsapp"
              ></use>
            </svg>
            <span>Whatsapp</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</div>
